import { useLayoutEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/** Start a newly chosen public page at its destination, preserving browser Back. */
export function useLandingRouteEntry() {
  const { pathname, hash, key } = useLocation();
  const navigationType = useNavigationType();
  useLayoutEffect(() => {
    if (navigationType === 'POP') return;
    let id = '';
    try { id = decodeURIComponent(hash.slice(1)); } catch { id = hash.slice(1); }
    const destination = id ? document.getElementById(id) : null;
    if (destination) destination.scrollIntoView({ block: 'start', behavior: 'instant' });
    else window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, hash, key, navigationType]);
}
